import React from 'react';
import { RoomsContainer } from './style';
import { RoomCard, EmptyRoomCard } from './RoomCard';
import { Loading } from '../../WithLoading/Loading';

export const RoomsList = ({ roomHandlers, cardSelected, channels, channelsLoading, onCreate }) => {
    return (
        <RoomsContainer>
            <Loading isLoading={channelsLoading}>
                {channels.map((channel, index) => (
                    <RoomCard cardSelected={cardSelected} {...channel} key={index} {...roomHandlers(channel)} />
                ))}
            </Loading>

            <EmptyRoomCard onAction={onCreate} />
        </RoomsContainer>
    );
};

RoomsList.defaultProps = {
    roomHandlers: () => {},
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/RoomsList.js